import * as actions from './statements.actions';
import { CommonConstants, SortInfo } from '../../global/interfaces';
import * as moment from 'moment';
import { DocumentsData, DocumentsFilter } from './statements.models';
import { PaginationComponent, PaginationInfo } from 'atlas-pagination';
export interface State {
  loading: boolean;
  types: string[];
  documents: DocumentsData;
  mobile: DocumentsData;
  mobilePagination: PaginationInfo;
  filter: DocumentsFilter;
  sort: SortInfo;
  pagination: PaginationInfo;
  documentIds: string[];
}

export function financialYearDate(): string {
  const todayDate = moment().utc().format(CommonConstants.DBDateFormat),
    year = moment().utc().year();
  let fromDate: string;
  if (todayDate > moment('01-07-' + year, CommonConstants.simpleDateFormatWithDashInAU).format(CommonConstants.DBDateFormat)) {
    fromDate = moment('01-07-' + year, CommonConstants.simpleDateFormatWithDashInAU).format(CommonConstants.DBDateFormat);
  } else {
    fromDate = moment('01-07-' + (year - 1), CommonConstants.simpleDateFormatWithDashInAU).format(CommonConstants.DBDateFormat);
  }
  return fromDate;
}

export const initialState: State = {
  loading: false,
  types: [],
  documents: {
    data: [],
    total: 0
  },
  mobile: {
    data: [],
    total: 0
  },
  mobilePagination: {
    page: 1,
    itemsByPage: 10,
    total: 0,
  },
  filter: {
    type: [],
    from: undefined,
    to: moment().utc().format(CommonConstants.DBDateFormat),
  },
  sort: {
    column: 'date',
    reverse: true
  },
  pagination: {
    page: 1,
    itemsByPage: 10,
    total: 0,
  },
  documentIds: []
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    /**
     * Sub-Types
     */
    case actions.ActionTypes.LOAD_STATEMENT_TYPES:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_STATEMENT_TYPES_SUCCESS:
      return { ...state, loading: false, types: action.payload };
    case actions.ActionTypes.LOAD_STATEMENT_TYPES_FAILED:
      return { ...state, loading: false };

    /**
     * Desktop
     */
    case actions.ActionTypes.LOAD_STATEMENTS:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_STATEMENTS_SUCCESS:
      return { ...state, loading: false, documents: action.payload };
    case actions.ActionTypes.LOAD_STATEMENTS_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.LOAD_STATEMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        documents: action.payload,
      };
    }

    /**
     * Mobile
     */
    case actions.ActionTypes.LOAD_MOBILE_STATEMENTS:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_MOBILE_STATEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        mobile: {
          total: action.payload.total,
          data: [...state.mobile.data, ...action.payload.data]
        }
      };
    case actions.ActionTypes.LOAD_MOBILE_STATEMENTS_FAILED:
      return { ...state, loading: false };
    case actions.ActionTypes.SET_STATEMENTS_MOBILE_PAGINATION:
      return { ...state, mobilePagination: action.payload };

    case actions.ActionTypes.SET_STATEMENTS_TYPE:
      return { ...state, filter: { ...state.filter, type: action.payload }, pagination: { ...state.pagination, page: 1 } };
    case actions.ActionTypes.SET_STATEMENTS_FROM:
      return { ...state, filter: { ...state.filter, from: action.payload }, pagination: { ...state.pagination, page: 1 } };
    case actions.ActionTypes.SET_STATEMENTS_TO:
      return { ...state, filter: { ...state.filter, to: action.payload }, pagination: { ...state.pagination, page: 1 } };

    case actions.ActionTypes.SET_STATEMENTS_SORT:
      return { ...state, sort: action.payload };

    case actions.ActionTypes.SET_STATEMENTS_PAGINATION:
      return { ...state, pagination: action.payload };

    case actions.ActionTypes.RESET_STATEMENTS:
      return { ...initialState };

    /**
     * Resets all state fields except for filters
     */
    case actions.ActionTypes.RESET_MOBILE_STATEMENTS:
      return { ...initialState, filter: { ...state.filter } };

    default:
      return state;
  }
}

